import { Box, Button, Typography } from '@mui/material';
import CustomTooltip from '../../common/components/CustomTooltip';
import Panel from '../../elements/Panel/Panel';
import { openInviteUserModal } from '../store-actions/invite-user-store-actions';

export interface MembersHeaderProps {
  isInviteUserDisabled: boolean;
}

const MembersHeader: React.FC<React.PropsWithChildren<MembersHeaderProps>> = ({
  isInviteUserDisabled,
}) => {
  const tooltipTitle = isInviteUserDisabled
    ? 'Your user role prevents you from performing this action'
    : 'Invite your teammates';

  return (
    <Panel p={2}>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography color='primary.main' variant='h6' component='h4'>
          Members
        </Typography>
        <CustomTooltip title={tooltipTitle}>
          <Box display='flex' alignItems='center'>
            <Button
              variant='outlined'
              onClick={() => openInviteUserModal()}
              color='success'
              disabled={isInviteUserDisabled}>
              {'Invite User'}
            </Button>
          </Box>
        </CustomTooltip>
      </Box>

      <Box color='text.primary'>
        <Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
          An easy to use UI to help administrators manage user access to the
          organization, inviting and provisioning, blocking and deleting users,
          controlling user roles and access.
        </Typography>
      </Box>
    </Panel>
  );
};

export default MembersHeader;
